import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = "https://www.mypanther.fr/web/image/website/1/logo/My%20Panther?unique=501ee63";

export default function ClientLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/client/login`, { email, password, portal: 'client' }, { withCredentials: true });
      navigate('/espace-client/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur de connexion');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <Card className="w-full max-w-sm border-slate-200 shadow-lg">
        <CardContent className="pt-8 pb-6 px-6">
          <div className="text-center mb-8">
            <img src={LOGO_URL} alt="Panther" className="h-12 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-slate-900">Espace Client</h1>
            <p className="text-sm text-slate-500 mt-1">Suivez vos commandes en ligne</p>
          </div>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-sm">Email</Label>
              <Input data-testid="client-login-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="votre@email.com" required />
            </div>
            <div className="space-y-1.5">
              <Label className="text-sm">Mot de passe</Label>
              <Input data-testid="client-login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <Button data-testid="client-login-submit" type="submit" className="w-full bg-slate-900 hover:bg-slate-800" disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
